import {
	STAFF_MINE_LOADING_TRUE,
	STAFF_MINE_LOADING_FALSE,
	STAFF_MINE_GET,
	STAFF_MINE_ERROR
} from '../actions/types';

const initialState = {
	loading: false,
	staff: null,
	staffChecked: false,
	staffs_errors: null
}

export default function(state = initialState, action) {
	switch(action.type) {
		case STAFF_MINE_LOADING_TRUE:
			return {
				...state,
				loading: true
			}
		case STAFF_MINE_LOADING_FALSE:
			return {
				...state,
				loading: false,
				staffChecked: true
			}
		case STAFF_MINE_GET:
			return {
				...state,
				staff: action.payload,
				staffs_errors: null
			}
		case STAFF_MINE_ERROR:
			return {
				...state,
				staffs_errors: {
					...state.staffs_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
